<form snDrawer (ngSubmit)="onFormSubmit()">
  <sn-drawer-header [title]="'shares.configShare' | t">
    <sn-drawer-header-actions>
      <sn-icon-button icon="close" snDrawerClose snDrawerNavButton></sn-icon-button>
    </sn-drawer-header-actions>
  </sn-drawer-header>

  <sn-share-details-v2 [share]="share"></sn-share-details-v2>

  <sn-drawer-content indented>
    <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
  </sn-drawer-content>

  <sn-drawer-footer class="share-config-drawer-v2__footer">
    <sn-flat-button type="button" snDrawerClose class="share-config-drawer-v2__footer-button">{{ 'common.cancel' | t }}</sn-flat-button>
    <sn-flat-button color="accent" type="submit" [disabled]="form.invalid" class="share-config-drawer-v2__footer-button">{{ 'common.saveChanges' | t }}</sn-flat-button>
  </sn-drawer-footer>
</form>

